import { render, staticRenderFns } from "./TributacaoForm.vue?vue&type=template&id=de40eef4"
import script from "./TributacaoForm.vue?vue&type=script&lang=js"
export * from "./TributacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports